import React from "react"
import type { ChakraProps } from "@chakra-ui/react"
import { Grid, GridItem } from "@chakra-ui/react"
import { colours } from "@shared/ui.design-system"

export const PDPHeaderLayout: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => (
  <Grid
    data-testid="PDPHeaderLayout"
    w="full"
    maxW="90rem"
    gridTemplateColumns={{
      base: "1fr",
      md: "1fr",
      lg: "7fr 8fr",
      xl: "1fr 1fr",
    }}
  >
    {children}
  </Grid>
)

export const GalleryLayout: React.FC<
  ChakraProps & { children: React.ReactNode }
> = ({ children, ...chakraProps }) => (
  <GridItem
    data-testid="GalleryLayout"
    colSpan={{ base: 3, md: 4, lg: 1 }}
    rowStart={1}
    {...chakraProps}
    bg={colours.secondary.soft}
  >
    {children}
  </GridItem>
)

export const CoreLayout: React.FC<
  ChakraProps & {
    hasInfo: boolean
    children: React.ReactNode
  }
> = ({ children, hasInfo }) => (
  <GridItem
    data-testid="PDPCoreLayout"
    rowStart={{ base: 2, lg: 1 }}
    colStart={{ base: 1, lg: 2 }}
    px={{ base: 2, md: 10 }}
    pt={{ base: 1, md: 2, lg: hasInfo ? 1 : 8 }}
    pb={{ base: 0, lg: 3 }}
    minHeight={100}
  >
    {children}
  </GridItem>
)

export const InfoBarLayout: React.FC<
  ChakraProps & { children: React.ReactNode }
> = ({ children, ...chakraProps }) => (
  <GridItem data-testid="InfoBarLayout" {...chakraProps}>
    {children}
  </GridItem>
)

export const ProductInfoLayout: React.FC<
  ChakraProps & { hasInfo: boolean; children: React.ReactNode }
> = ({ children, hasInfo, ...chakraProps }) => (
  <GridItem
    data-testid="ProductInfoLayout"
    mt={{ base: hasInfo ? 1 : 0, md: hasInfo ? 2 : 0, lg: 0 }}
    {...chakraProps}
  >
    {children}
  </GridItem>
)

export const ProductPricingLayout: React.FC<
  ChakraProps & { children: React.ReactNode }
> = ({ children, ...chakraProps }) => (
  <GridItem
    data-testid="ProductPricingLayout"
    mt={1}
    mb={{ base: "0px", md: 3, lg: 2 }}
    {...chakraProps}
  >
    {children}
  </GridItem>
)
